import React from 'react';
import { Blueprint } from 'types/rest/assetCatalogTypes';
import BlueprintCard from './BlueprintCard';
import BlueprintEmptyState from './BlueprintEmptyState';
import styles from './BlueprintGrid.module.css';

interface Props {
  blueprints: Blueprint[];
  onOpen: (id: string) => void;
  onAddToCatalog: (id: string) => void;
}

const BlueprintGrid = ({ blueprints, onOpen, onAddToCatalog }: Props) => {
  if (blueprints.length === 0) return <BlueprintEmptyState />;

  return (
    <div className={styles.grid}>
      {blueprints.map(bp => (
        <BlueprintCard key={bp.id} blueprint={bp} onOpen={onOpen} onAddToCatalog={onAddToCatalog} />
      ))}
    </div>
  );
};

export default BlueprintGrid;
